import React,{useState} from 'react'
import CmsNavbar from '../../CmsComponents/CmsNavbar';
import CmsSidebar from '../../CmsComponents/CmsSidebar';
import SocialLinks from '../../CmsComponents/SocialAdmin';

function SocialLinksPage() {
    const [isOpen,setIsOpen]= useState(false);

    function HandleClicked() {
        setIsOpen(!isOpen);
    }

    return (
        <div>
            <CmsNavbar action={HandleClicked} />
            <CmsSidebar isOpen={isOpen} />
            <SocialLinks isOpen={isOpen} />
        </div>
    )
}

export default SocialLinksPage;